var analytics = require('./analytics');

class AnalyticsHelper {
    init () {
        analytics.init();
    }
}

const analyticsHelper = new AnalyticsHelper();
module.exports = analyticsHelper;
